import { put, fork, takeEvery } from 'redux-saga/effects';

import { showSuccessToast } from '@/components/Toastr/actions';
import i18n from '@/i18n'; // Updated by script
import { COPY_TO_CLIPBOARD } from '@/components/CopyToClipBoard/constants';
const { t } = i18n;
export function* clipBoardWatcher({ text }: { text: string }) {
  yield put(showSuccessToast(text || t('email.copied')));
}
export default function* root() {
  yield [takeEvery( COPY_TO_CLIPBOARD as any, clipBoardWatcher)];
}
